var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Icon from "metabase/components/Icon";
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
HeaderContainer.defaultProps = {
  role: "button",
  tabIndex: "0"
};
export const Header = styled.span`
  display: flex;
  align-items: center;
`;
const ICON_VARIANTS = {
  "right-down": {
    collapsed: "chevronright",
    expanded: "chevrondown"
  },
  "up-down": {
    collapsed: "chevrondown",
    expanded: "chevronup"
  }
};
export const ToggleIcon = styled((_a) => {
  var _b = _a, { isExpanded, variant, size = 12 } = _b, props = __objRest(_b, ["isExpanded", "variant", "size"]);
  const { collapsed, expanded } = ICON_VARIANTS[variant];
  const name = isExpanded ? expanded : collapsed;
  return /* @__PURE__ */ _jsx(Icon, __spreadValues({
    name,
    size
  }, props));
})`
  ${(props) => css`
    margin-${props.position === "left" ? "right" : "left"}: 0.5rem;
  `};
`;
